/* Bound the same product thumbnail before the review app initializes. No review data is changed. */
(function () {
  'use strict';
  var script = document.currentScript;
  var product = window.shopifyObj;
  if (!script || window.isTrustooReviewsExecuted !== false || !product ||
      product.productId !== Number(script.dataset.productId) ||
      !Array.isArray(product.productImage) || !product.productImage[0]) return;
  try {
    var original = new URL(product.productImage[0], location.origin);
    var thumbnail = new URL(script.dataset.productThumbnail, location.origin);
    if (original.protocol !== 'https:' || original.origin !== location.origin ||
        original.origin !== thumbnail.origin || original.pathname !== thumbnail.pathname ||
        original.searchParams.has('width') || thumbnail.searchParams.get('width') !== '320') return;
    // Keep existing transformations and unknown query parameters untouched.
    if (Array.from(original.searchParams.keys()).some(function (key) { return key !== 'v'; })) return;
    thumbnail.searchParams.delete('width');
    if (thumbnail.search !== original.search) return;
    original.searchParams.set('width', '320');
    product.productImage[0] = original.href;
  } catch (_) {
    // An unavailable or changed integration retains the original app behavior.
  }
})();
